var SCAAFFCustomerReferSetting = {
    "program": {
        "active": false,
        "shop": "muse-india.myshopify.com",
        "incentive": {
            "type": "percentage",
            "value": "15.00",
            "price_rule_id": "",
            "coupon": ""
        },
        "program": "ODk5MzY="
    },
    "design": {
        "refer_customer_button": {
            "refer_button_text": "Refer & Earn",
            "refer_background_color": "#e74714",
            "refer_text_color": "#ffffff",
            "web_position": "right-bottom",
            "mobile_position": "right-bottom"
        },
        "refer_customer_invite": {
            "popup_header": "Invite & Get 20% from friend's orders",
            "popup_description": "Send your friends a 15% discount on their purchase. Once they make a purchase, you'll earn 20% for each order as well! This reward can be redeemed on your next order.",
            "button_text_get_invite": "Get invite link",
            "button_copy_invite": "Copy invite link",
            "popup_background_color": "#e74714",
            "popup_text_color": "#ffffff"
        },
        "refer_customer_incentive_popup": {
            "shop_header": "You legend! You just got 15% Off",
            "shop_description": "Congrats! Your friend has gifted you a coupon. that will be automatically applied at the checkout page.",
            "shop_button_text": "Shop now",
            "shop_background_color": "#e74714",
            "shop_text_color": "#ffffff"
        }
    }
}